import React, { useEffect, useState } from "react";
import Info from "../components/CoinPage/Info";
import LineChart from "../components/CoinPage/LineChart";
import ToggleComponents from "../components/CoinPage/ToggleComponent";
import Header from "../components/Common/Header";
import Loader from "../components/Common/Loader";
import SelectCoins from "../components/ComparePage/SelectCoins";
import List from "../components/Dashboard/List";
import { get100Coins } from "../functions/get100Coins";
import { getCoinData } from "../functions/getCoinData";
import { getPrices } from "../functions/getPrices";
import { settingChartData } from "../functions/settingChartData";
import { settingCoinObject } from "../functions/settingCoinObject";

function Compare() {
  const [allCoins, setAllCoins] = useState([]);
  const [loading, setLoading] = useState(false);
  // id states
  const [crypto1, setCrypto1] = useState("bitcoin");
  const [crypto2, setCrypto2] = useState("ethereum");
  // data states
  const [coin1Data, setCoin1Data] = useState({});
  const [coin2Data, setCoin2Data] = useState({});
  // days state
  const [days, setDays] = useState(30);
  const [priceType, setPriceType] = useState("prices");
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    let isMounted = true;

    const loadAllCoins = async () => {
      const coins = await get100Coins();
      if (isMounted && coins) {
        setAllCoins(coins);
      }
    };

    loadAllCoins();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      setLoading(true);
      try {
        const data1 = await getCoinData(crypto1);
        const data2 = await getCoinData(crypto2);
        if (!isMounted) {
          return;
        }
        settingCoinObject(data1, setCoin1Data);
        settingCoinObject(data2, setCoin2Data);
        if (data1 && data2) {
          const prices1 = await getPrices(crypto1, days, priceType);
          const prices2 = await getPrices(crypto2, days, priceType);
          if (!isMounted) {
            return;
          }
          settingChartData(setChartData, prices1, prices2);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, [crypto1, crypto2, days, priceType]);

  const onCoinChange = (e, isCoin2) => {
    setLoading(true);
    if (isCoin2) {
      setCrypto2(e.target.value);
    } else {
      setCrypto1(e.target.value);
    }
  };

  const handleDaysChange = (e) => {
    setLoading(true);
    setDays(e.target.value);
  };

  const handlePriceTypeChange = (e) => {
    setLoading(true);
    setPriceType(e.target.value);
  };

  return (
    <div>
      <Header />
      {loading || !coin1Data?.id || !coin2Data?.id ? (
        <Loader />
      ) : (
        <>
          <SelectCoins
            allCoins={allCoins}
            crypto1={crypto1}
            crypto2={crypto2}
            onCoinChange={onCoinChange}
            days={days}
            handleDaysChange={handleDaysChange}
          />
          <div className="grey-wrapper">
            <List coin={coin1Data} />
          </div>
          <div className="grey-wrapper">
            <List coin={coin2Data} />
          </div>
          <div className="grey-wrapper">
            <ToggleComponents
              priceType={priceType}
              handlePriceTypeChange={handlePriceTypeChange}
            />
            <LineChart chartData={chartData} multiAxis={true} />
          </div>
          <Info title={coin1Data.name} desc={coin1Data.desc} />
          <Info title={coin2Data.name} desc={coin2Data.desc} />
        </>
      )}
    </div>
  );
}

export default Compare;
